import { Link } from "react-router-dom";

const columns = [
  {
    title: "栏目导航",
    links: [
      { label: "新番导视", to: "/guide" },
      { label: "连载新开", to: "/serial" },
      { label: "热门新番", to: "/hot" },
      { label: "关于我们", to: "/about" },
      { label: "常见问题", to: "/faq" },
    ],
  },
  {
    title: "热门作品",
    links: [
      { label: "白日梦游者", to: "/article/papaya-009" },
      { label: "轮回灯塔", to: "/article/papaya-012" },
      { label: "赤炎之刃", to: "/article/papaya-010" },
      { label: "猫咪邮差", to: "/article/papaya-011" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {/* brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-leaf-fill text-xl"></i>
              </span>
              <span className="font-heading text-2xl text-primary-300">
                番木瓜漫画
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-6 text-background-200/80">
              番木瓜漫画为你抢先带来本季新作、每日更新的最新上架内容、当季新番导视与连载新开情报，帮助每一位热爱漫画的读者快速锁定值得追的作品，热门新番同步追更。
            </p>
            <div className="mt-5 flex gap-3">
              {["ri-weibo-line", "ri-wechat-line", "ri-bilibili-line", "ri-mail-line"].map(
                (ic) => (
                  <a
                    key={ic}
                    href="#contact"
                    className="flex h-9 w-9 items-center justify-center rounded-full border border-background-200/30 text-background-100 transition hover:bg-primary-500 hover:border-primary-500"
                    aria-label="社区入口"
                  >
                    <i className={`${ic} text-sm`}></i>
                  </a>
                )
              )}
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="mb-4 text-sm font-bold text-primary-300">
                {col.title}
              </h4>
              <ul className="space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label + l.to}>
                    <Link
                      to={l.to}
                      className="text-sm text-background-200/80 transition hover:text-primary-300"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200/15 pt-6 sm:flex-row">
          <p className="text-xs text-background-200/60">
            © 2026 番木瓜漫画 · 本季新作抢先看，最新上架每日更新
          </p>
          <p className="text-xs text-background-200/60">
            联系方式：hello@fanmugua.example
          </p>
        </div>
      </div>
    </footer>
  );
}